import { createLead } from "./createLead";
import { getLeads } from "./getLeads";
import { handleLeadStatus } from "./handleLeadStatus";

export const leadsService = {
  getLeads,
  createLead,
  handleLeadStatus,
};
